// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toogle-container {
    display: flex;
    align-items: center;
}

.toogle-switch {
    position: relative;
    margin-right: 10px;
}

.toogle-switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    transition: 0.4s;
    border-radius: 30px;
    width: 120%;
}

.slider::before {
    position: absolute;
    content: "";
    height: calc(100% - 4px);
    width: calc(16% - 2px + 22%);
    left: 2px;
    bottom: 2px;
    background-color: white;
    transition: 0.4s;
    border-radius: 50%;
}

input:checked + .slider::before {
    transform: translateX(calc(150% + 4px));
}
`, "",{"version":3,"sources":["webpack://./src/styles/controls/Toogle.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,wBAAwB;IACxB,4BAA4B;IAC5B,SAAS;IACT,WAAW;IACX,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,uCAAuC;AAC3C","sourcesContent":[".toogle-container {\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.toogle-switch {\r\n    position: relative;\r\n    margin-right: 10px;\r\n}\r\n\r\n.toogle-switch input {\r\n    opacity: 0;\r\n    width: 0;\r\n    height: 0;\r\n}\r\n\r\n.slider {\r\n    position: absolute;\r\n    cursor: pointer;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    transition: 0.4s;\r\n    border-radius: 30px;\r\n    width: 120%;\r\n}\r\n\r\n.slider::before {\r\n    position: absolute;\r\n    content: \"\";\r\n    height: calc(100% - 4px);\r\n    width: calc(16% - 2px + 22%);\r\n    left: 2px;\r\n    bottom: 2px;\r\n    background-color: white;\r\n    transition: 0.4s;\r\n    border-radius: 50%;\r\n}\r\n\r\ninput:checked + .slider::before {\r\n    transform: translateX(calc(150% + 4px));\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
